// Styles for use with the lineage cartouches.

import { TabStyles } from '@tableau/widgets';
import { cssClass, divWithStyle, elideTextStyle, flexColumnStyle, flexRowStyle, Style } from '../../../data-catalog-shared';

const AnchorBlue = '#1A699E'; // from TFS 929971

const Colors = TabStyles.Colors;
const Spacing = TabStyles.Spacing;

const cartoucheSize = '45px';
const cartoucheLinkSize = '35px';
const cartoucheIconSize = '24px';
const lightBorder = '1px solid ' + Colors.F5;
const cartoucheBorder = '1px solid ' + Colors.F8;
const selectedBorder = '1px solid ' + AnchorBlue;

export const CartoucheWrapper = divWithStyle('CartoucheWrapper', {
  ...flexRowStyle,
  flex: '0 0 auto'
});

export const cartoucheIconStyle = cssClass('cartoucheIconStyle', {
  display: 'block',
  border: lightBorder,
  borderRadius: '50%',
  padding: '4.5px',
  width: cartoucheIconSize,
  height: cartoucheIconSize,
  $nest: {
    '&:hover': {
      border: cartoucheBorder
    }
  }
});

export const activeLineageItemType = cssClass('activeLineageItemType', {
  border: selectedBorder,
  backgroundColor: AnchorBlue
});

export const AnchoredLineageItemContainer = divWithStyle('AnchoredLineageItem', {
  height: cartoucheSize,
  display: 'flex',
  flexDirection: 'row',
  flex: 'none',
  $nest: {
    [`& .${cartoucheIconStyle}`]: {
      backgroundColor: Colors.F5,
      padding: '9.5px',
    },
    [`& .${activeLineageItemType}`]: {
      backgroundColor: AnchorBlue
    }
  }
});

export const anchorNameClass = cssClass('anchorName', elideTextStyle, {
  fontSize: TabStyles.Typography.Sizing.Large,
  maxWidth: '100%'
});

export const boldLineageItemClass = cssClass('boldLineageItem', {
  fontWeight: 'bold'
});

export const lineageIconButtonStyle: Style = {
  height: cartoucheLinkSize,
};

export const lineageIconButtonClass = cssClass('lineageIconButton', lineageIconButtonStyle);

export const cartoucheIconButtonStyle: Style = {
  ...lineageIconButtonStyle,
  $nest: {
    '&:not(:last-of-type)': {
      marginBottom: Spacing.LargeSpace
    }
  }
};

export const cartoucheIconButtonClass = cssClass('cartoucheIconButton', cartoucheIconButtonStyle);

export const ContentInfoContainer = divWithStyle('ContentInfoContainer', {
  ...flexColumnStyle,
  marginTop: 5,
  marginLeft: Spacing.MediumSpace,
});

export const baseContentInfoItemStyle: Style = {
  ...flexColumnStyle,
  flex: '1',
  color: TabStyles.Typography.Color.Primary,
  textDecoration: 'none',
  minWidth: 0
};

export const lineageContentInfoItemStyle: Style = {
  ...baseContentInfoItemStyle,
  overflow: 'hidden',
  marginLeft: 16
};

export const anchoredContentInfoItemStyle: Style = {
  ...baseContentInfoItemStyle,
  marginLeft: Spacing.MediumSpace
};

export const lineageContentInfoItemClass = cssClass('LineageContentInfoItem', lineageContentInfoItemStyle);

export const anchoredContentInfoItemClass = cssClass('AnchoredContentInfoItem', anchoredContentInfoItemStyle);

export const LineageContentInfoItemAnchorRow = divWithStyle('LineageContentInfoItemAnchorRow', {
  ...flexColumnStyle,
  flex: '1 1 0%',
  alignItems: 'flex-start',
  minHeight: 0
});

export const LineageContentInfoItemAnchorRowSelected = divWithStyle('LineageContentInfoItemAnchorRowSelected', {
  display: 'flex',
  alignItems: 'center'
});

export const LineageContentInfoItemLabelRow = divWithStyle('LineageContentInfoItemLabelRow', {
  flex: '1 1 0%',
  display: 'flex',
  alignItems: 'center',
});

export const lineageContentInfoItemSpaceRow = cssClass('lineageContentInfoItemSpaceRow', {
  paddingTop: '4px', // to compensate for the height of the bar (below), to center label with icon
});

export const LineageContentInfoItemBarRow = divWithStyle('LineageContentInfoItemBarRow', {
  flex: 'none',
});

export const cartoucheContentInfoItemStyle: Style = {
  height: cartoucheLinkSize,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  color: TabStyles.Typography.Color.Primary,
  textDecoration: 'none',
  $nest: {
    '&:not(:last-of-type)': {
      marginBottom: Spacing.LargeSpace
    }
  }
};

export const cartoucheContentInfoItemClass = cssClass('CartoucheContentInfoItem', cartoucheContentInfoItemStyle);

export const filteredOnItemIndicatorClass = cssClass('filteredOnItemIndicator', {
  paddingRight: TabStyles.Spacing.SmallSpace,
});

export const CartoucheConnectorLine = divWithStyle('CartoucheConnectorLine', {
  width: 22.5,
  borderRight: lightBorder,
  height: Spacing.LargeSpace,
  flex: 'none',
});

export const CartoucheIconContainer = divWithStyle('CartoucheIconContainer', {
  ...flexColumnStyle,
  padding: '5px 4px',
  border: lightBorder,
  borderRadius: cartoucheLinkSize,
});

export const SingleLineageItemContainer = divWithStyle('SingleLineageItem', {
  marginLeft: Spacing.DefaultSpace,
});
